module.exports = __webpack_public_path__ + "static/media/blankImage.1e8faf1b.svg";